const employmentData =
[
    {
        'coordinates': [
            {
                "Date": "1/1/2008",
                "Employees": 77.2
            },
            {
                "Date": "2/1/2008",
                "Employees": 77.3
            },
            {
                "Date": "3/1/2008",
                "Employees": 77.6
            },
            {
                "Date": "4/1/2008",
                "Employees": 78
            },
            {
                "Date": "5/1/2008",
                "Employees": 79.2
            },
            {
                "Date": "6/1/2008",
                "Employees": 80.3
            },
            {
                "Date": "7/1/2008",
                "Employees": 80.4
            },
            {
                "Date": "8/1/2008",
                "Employees": 82.7
            },
            {
                "Date": "9/1/2008",
                "Employees": 83.6
            },
            {
                "Date": "10/1/2008",
                "Employees": 84.8
            },
            {
                "Date": "11/1/2008",
                "Employees": 86.1
            },
            {
                "Date": "12/1/2008",
                "Employees": 86.3
            },
            {
                "Date": "1/1/2009",
                "Employees": 86.4
            },
            {
                "Date": "2/1/2009",
                "Employees": 85.9
            },
            {
                "Date": "3/1/2009",
                "Employees": 85.2
            },
            {
                "Date": "4/1/2009",
                "Employees": 83.9
            },
            {
                "Date": "5/1/2009",
                "Employees": 82.2
            },
            {
                "Date": "6/1/2009",
                "Employees": 81
            },
            {
                "Date": "7/1/2009",
                "Employees": 79.9
            },
            {
                "Date": "8/1/2009",
                "Employees": 80
            },
            {
                "Date": "9/1/2009",
                "Employees": 79.4
            },
            {
                "Date": "10/1/2009",
                "Employees": 78.3
            },
            {
                "Date": "11/1/2009",
                "Employees": 77.9
            },
            {
                "Date": "12/1/2009",
                "Employees": 77.7
            },
            {
                "Date": "1/1/2010",
                "Employees": 77.8
            },
            {
                "Date": "2/1/2010",
                "Employees": 78.6
            },
            {
                "Date": "3/1/2010",
                "Employees": 79.1
            },
            {
                "Date": "4/1/2010",
                "Employees": 79.2
            },
            {
                "Date": "5/1/2010",
                "Employees": 80.3
            },
            {
                "Date": "6/1/2010",
                "Employees": 80.2
            },
            {
                "Date": "7/1/2010",
                "Employees": 80.9
            },
            {
                "Date": "8/1/2010",
                "Employees": 81.2
            },
            {
                "Date": "9/1/2010",
                "Employees": 82
            },
            {
                "Date": "10/1/2010",
                "Employees": 82.7
            },
            {
                "Date": "11/1/2010",
                "Employees": 83.4
            },
            {
                "Date": "12/1/2010",
                "Employees": 84
            },
            {
                "Date": "1/1/2011",
                "Employees": 83.9
            },
            {
                "Date": "2/1/2011",
                "Employees": 83.1
            },
            {
                "Date": "3/1/2011",
                "Employees": 84.4
            },
            {
                "Date": "4/1/2011",
                "Employees": 86
            },
            {
                "Date": "5/1/2011",
                "Employees": 87.6
            },
            {
                "Date": "6/1/2011",
                "Employees": 88.3
            },
            {
                "Date": "7/1/2011",
                "Employees": 87.8
            },
            {
                "Date": "8/1/2011",
                "Employees": 88.6
            },
            {
                "Date": "9/1/2011",
                "Employees": 89.3
            },
            {
                "Date": "10/1/2011",
                "Employees": 89.5
            },
            {
                "Date": "11/1/2011",
                "Employees": 89.6
            },
            {
                "Date": "12/1/2011",
                "Employees": 89.4
            },
            {
                "Date": "1/1/2012",
                "Employees": 89.7
            },
            {
                "Date": "2/1/2012",
                "Employees": 89.3
            },
            {
                "Date": "3/1/2012",
                "Employees": 88.9
            },
            {
                "Date": "4/1/2012",
                "Employees": 87.9
            },
            {
                "Date": "5/1/2012",
                "Employees": 87.6
            },
            {
                "Date": "6/1/2012",
                "Employees": 85.8
            },
            {
                "Date": "7/1/2012",
                "Employees": 84.6
            },
            {
                "Date": "8/1/2012",
                "Employees": 83
            },
            {
                "Date": "9/1/2012",
                "Employees": 81.6
            },
            {
                "Date": "10/1/2012",
                "Employees": 79.4
            },
            {
                "Date": "11/1/2012",
                "Employees": 79.1
            },
            {
                "Date": "12/1/2012",
                "Employees": 78.9
            },
            {
                "Date": "1/1/2013",
                "Employees": 78.4
            },
            {
                "Date": "2/1/2013",
                "Employees": 79.3
            },
            {
                "Date": "3/1/2013",
                "Employees": 79.6
            },
            {
                "Date": "4/1/2013",
                "Employees": 78.1
            },
            {
                "Date": "5/1/2013",
                "Employees": 78.6
            },
            {
                "Date": "6/1/2013",
                "Employees": 78.8
            },
            {
                "Date": "7/1/2013",
                "Employees": 78.4
            },
            {
                "Date": "8/1/2013",
                "Employees": 78
            },
            {
                "Date": "9/1/2013",
                "Employees": 77.2
            },
            {
                "Date": "10/1/2013",
                "Employees": 77.2
            },
            {
                "Date": "11/1/2013",
                "Employees": 77
            },
            {
                "Date": "12/1/2013",
                "Employees": 76.7
            },
            {
                "Date": "1/1/2014",
                "Employees": 76
            },
            {
                "Date": "2/1/2014",
                "Employees": 75
            },
            {
                "Date": "3/1/2014",
                "Employees": 73.7
            },
            {
                "Date": "4/1/2014",
                "Employees": 74.1
            },
            {
                "Date": "5/1/2014",
                "Employees": 74
            },
            {
                "Date": "6/1/2014",
                "Employees": 74
            },
            {
                "Date": "7/1/2014",
                "Employees": 74.4
            },
            {
                "Date": "8/1/2014",
                "Employees": 73.2
            },
            {
                "Date": "9/1/2014",
                "Employees": 72.6
            },
            {
                "Date": "10/1/2014",
                "Employees": 71.2
            },
            {
                "Date": "11/1/2014",
                "Employees": 70.6
            },
            {
                "Date": "12/1/2014",
                "Employees": 69.7
            },
            {
                "Date": "1/1/2015",
                "Employees": 68.9
            },
            {
                "Date": "2/1/2015",
                "Employees": 68.6
            },
            {
                "Date": "3/1/2015",
                "Employees": 68.1
            },
            {
                "Date": "4/1/2015",
                "Employees": 67
            },
            {
                "Date": "5/1/2015",
                "Employees": 66
            },
            {
                "Date": "6/1/2015",
                "Employees": 65.1
            },
            {
                "Date": "7/1/2015",
                "Employees": 64.1
            },
            {
                "Date": "8/1/2015",
                "Employees": 62.8
            },
            {
                "Date": "9/1/2015",
                "Employees": 61.6
            },
            {
                "Date": "10/1/2015",
                "Employees": 60.5
            },
            {
                "Date": "11/1/2015",
                "Employees": 58.8
            },
            {
                "Date": "12/1/2015",
                "Employees": 57.1
            },
            {
                "Date": "1/1/2016",
                "Employees": 55.4
            },
            {
                "Date": "2/1/2016",
                "Employees": 53.4
            },
            {
                "Date": "3/1/2016",
                "Employees": 52.1
            },
            {
                "Date": "4/1/2016",
                "Employees": 51.1
            },
            {
                "Date": "5/1/2016",
                "Employees": 49.9
            },
            {
                "Date": "6/1/2016",
                "Employees": 49.2
            },
            {
                "Date": "7/1/2016",
                "Employees": 48.9
            },
            {
                "Date": "8/1/2016",
                "Employees": 48.9
            },
            {
                "Date": "9/1/2016",
                "Employees": 48.9
            },
            {
                "Date": "10/1/2016",
                "Employees": 49.7
            },
            {
                "Date": "11/1/2016",
                "Employees": 50.3
            },
            {
                "Date": "12/1/2016",
                "Employees": 50.4
            },
            {
                "Date": "1/1/2017",
                "Employees": 50.7
            },
            {
                "Date": "2/1/2017",
                "Employees": 50.9
            },
            {
                "Date": "3/1/2017",
                "Employees": 51.2
            },
            {
                "Date": "4/1/2017",
                "Employees": 51.8
            },
            {
                "Date": "5/1/2017",
                "Employees": 51.9
            },
            {
                "Date": "6/1/2017",
                "Employees": 52
            },
            {
                "Date": "7/1/2017",
                "Employees": 52
            },
            {
                "Date": "8/1/2017",
                "Employees": 52.5
            },
            {
                "Date": "9/1/2017",
                "Employees": 52.8
            },
            {
                "Date": "10/1/2017",
                "Employees": 52.7
            },
            {
                "Date": "11/1/2017",
                "Employees": 52.1
            },
            {
                "Date": "12/1/2017",
                "Employees": 51.7
            },
            {
                "Date": "1/1/2018",
                "Employees": 51.8
            }
        ]
    }
];

export default employmentData;


// WEBPACK FOOTER //
// ./src/employment-data.js